import { NgModule } from '@angular/core';
import { ThreeSixtyViewerComponent } from './three-sixty-viewer.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { ThreeSixtyViewerLabelComponent } from './components/three-sixty-viewer-label/three-sixty-viewer-label.component';
import { ThreeSixtyViewerControlsComponent } from './components/three-sixty-viewer-controls/three-sixty-viewer-controls.component';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { ThreeSixtyViewerModalBodyComponent } from './components/three-sixty-viewer-modal-body/three-sixty-viewer-modal-body.component';
import { ThreeSixtyViewerCoreComponent } from './components/three-sixty-viewer-core/three-sixty-viewer-core.component';

@NgModule({
  declarations: [
    ThreeSixtyViewerComponent,
    ThreeSixtyViewerLabelComponent,
    ThreeSixtyViewerControlsComponent,
    ThreeSixtyViewerModalBodyComponent,
    ThreeSixtyViewerCoreComponent,
  ],
  imports: [
    CommonModule,
    NzSpinModule,
    NzDividerModule,
    TranslateModule,
    NzButtonModule,
    NzIconModule,
    NzModalModule,
  ],
  exports: [ThreeSixtyViewerComponent],
})
export class ThreeSixtyViewerModule {}
